export default function PushConnectionBanner({ status, error, onConnect }) {
    const connected = status === 'connected'
    const unavailable = status === 'blocked' || status === 'unsupported'
    const checking = status === 'checking'
    const title = connected ? 'Уведомления подключены' : checking ? 'Подключаем уведомления…'
        : status === 'blocked' ? 'Уведомления заблокированы'
            : status === 'unsupported' ? 'Push в этом браузере недоступны'
                : status === 'error' ? 'Не удалось подключить уведомления' : 'Уведомления не подключены'
    const description = status === 'blocked' ? 'Разрешите уведомления для сайта в настройках браузера'
        : status === 'unsupported' ? 'Уведомления по-прежнему доступны здесь, в колокольчике'
            : status === 'error' ? error : !connected && !checking ? 'Подключите, чтобы получать их вне приложения' : null
    const tone = connected ? 'ok' : status === 'error' || status === 'blocked' ? 'warn' : undefined
    return (
        <div role="status" className="hp-banner" data-tone={tone}>
            <span className="hp-banner-icon"><i className={`ti ti-${connected ? 'bell-check' : tone === 'warn' ? 'bell-off' : 'bell-plus'}`} aria-hidden="true" /></span>
            <div className="hp-banner-text">
                <p style={{ fontSize: '12px', fontWeight: '600', color: connected ? '#059669' : '#374151' }}>{title}</p>
                {description && <p style={{ margin: '3px 0 0', fontSize: '11px', color: '#6B7280', lineHeight: '1.5' }}>{description}</p>}
            </div>
            {!connected && !checking && !unavailable && (
                <button onClick={onConnect}>
                    {status === 'error' ? 'Повторить' : 'Подключить'}
                </button>
            )}
        </div>
    )
}
